import { render, staticRenderFns } from "./WorkflowBuilderPage.vue?vue&type=template&id=3f2e1232&scoped=true"
import script from "./WorkflowBuilderPage.vue?vue&type=script&lang=js"
export * from "./WorkflowBuilderPage.vue?vue&type=script&lang=js"
import style0 from "./WorkflowBuilderPage.vue?vue&type=style&index=0&id=3f2e1232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2e1232",
  null
  
)

export default component.exports